function a(f, i, d) {
  return f === f && (d !== void 0 && (f = f <= d ? f : d), i !== void 0 && (f = f >= i ? f : i)), f;
}
export {
  a as default
};
